module.exports = __webpack_public_path__ + "static/media/ic_warm_water.dc3ac4d2.png";